const resources = {
    giftCardTitle: 'Carte-cadeau',
    free: 'Gratuit'
};

export default function getResource(label) {
    return resources[label];
}
